module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic07.074b431.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic07.jpg
// module id = 507
// module chunks = 1